module.exports = __webpack_public_path__ + "img/avatar.a7cb55f0.svg";